import { useParams, useLocation, useNavigate } from "react-router-dom";
import { userByMailUrl } from "../Url";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { FaLink } from "react-icons/fa6";
import { FaPhoneFlip, FaWhatsapp } from "react-icons/fa6";
import { GrMail } from "react-icons/gr";
import { mailUrl, staticUrl } from "../Url";
import { useReactToPrint } from 'react-to-print';
import {html2pdf} from 'html2pdf.js'

const DetailPage = () => {
  const params = useParams();
  const location = useLocation();
  console.log(location);
  const [user, setUser] = useState({});
  const storedToken = window.localStorage.getItem("token");
  const [load, setLoad] = useState(false);
  const [lien, setLien] = useState("");
  const [message, setMessage] = useState("");
  const [text, setText] = useState("");
  const [typ, setTyp] = useState("");
  const [url, setUrl] = useState("");
  const navigate = useNavigate()

  const [identification, setIdentification] = useState({
    id: "",
    denomination: "",
    sector: "",
    entreprise_email: "",
    ncc: "",
    nrc: "",
    entreprise_phone: "",
    address: "",
    website: "",
  });

  const admin = JSON.parse(window?.localStorage.getItem("userData") ?? "{}");
  const [isPme, setIsPme] = useState(false);
  const tableRef = React.createRef();
  const [print, setPrint] = useState(false);

  function formatDate(dateActuelle) {
    
    const jour = dateActuelle.getDate();
    const mois = dateActuelle.getMonth() + 1; // Les mois sont 0-indexés, donc on ajoute 1
    const annee = dateActuelle.getFullYear();
    const heures = dateActuelle.getHours();
    const minutes = dateActuelle.getMinutes();
    const secondes = dateActuelle.getSeconds();

    return `${jour}-${mois}-${annee} à ${heures}:${minutes}:${secondes}`;
  }

  function roleUser(role){

    return role === "CLIENT" ? "Superviseur" : "Admin";
  }

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
    documentTitle: `profil-généré-par-${admin?.firstname}_${admin?.firstname}-le-${formatDate(new Date())}`.toLowerCase(),
    onBeforePrint: () => {
      setPrint(true)
    },
    onBeforeGetContent: () => {
      setPrint(true)
    },
    onPrintError: () => {
      setPrint(true)
    },
    onAfterPrint: () => {
      console.log('Statistique générées avec succès!')
      setPrint(false)
    },
  });

  useEffect(() => {
    if(!admin || !admin?.id){
      navigate('/login')
    }
  }, [params]);

  const handleChange = (e) => {
    setIdentification({
      ...identification,
      [e.target.name]: e.target.value,
      id: Date.now(),
    });
  };

  useEffect(() => {
    axios
      .post(
        userByMailUrl,
        { email: params.name },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data, "data");
        setUser(response.data);
          let ids = {};
          if(response.data?.startups && response.data?.startups[0]){
            ids = response.data?.startups[0];
            setIsPme(false)
          }
          if(response.data?.pmes && response.data?.pmes[0]){
            ids = response.data?.pmes[0];
            setIsPme(true)
          }

        setIdentification(ids);
      })
      .catch((err) => {
        console.log(err);
        console.log(err);
      });
  }, [params]);

  const handleDetailClick = (email) => {
    setLoad(true);
    axios
      .post(
        mailUrl,
        { email: email, lien: lien, message: message, type: typ },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        setLoad(false);
        alert("Mail envoyé avec sucès");
        console.log(response);
      })
      .catch((err) => {
        setLoad(false);
        console.log(err);
        console.log(err);
      });
  };

  
  function handleMail(type){
    if(type === "calendar"){
      setText("Formulaire d'envoie de prise de rendez-vous")
      setTyp(type)
      setLien('https://calendly.com/gudepme')
      setMessage("Dans le cadre de votre demande effectuée sur la plateforme GUE-PME, vous êtes invité(e) au siège de GUE-PME pour rencontrer un conseiller client.\n\nPrière imprimer la lettre de RDV en pièce jointe et de prendre votre RDV.")
    }
    if(type === "finalisation"){
      setTyp(type)
      setLien('')
      setText("Notification de finalisation de procédure")
      setMessage("Dans le cadre de votre demande effectuée sur la plateforme GUE-PME, nous vous remercions de votre passage au siège de GUE-PME pour rencontrer un conseiller client.\n\nVotre dossier est à présent à l'étape de validation par nos services. Vous serez prochainement informé(e) de la suite donnée à votre demande.\n\nPour tout besoin d'informations veuillez nous contacter : 20 27 00 00 00.")
    }
    if(type === "information"){
      setTyp(type)
      setLien("https://sesame-ochre.vercel.app/completer-une-demande/"+user.email)
      setText("Demande d'informations supplementaires")
      setMessage("Dans le cadre de votre demande effectuée sur la plateforme GUE-PME, nous vous contactons pour des compléments d'informations sur votre dossier concernant les éléments suivants :\n- Le montant de votre besoin financier\n- Le Bilan financier\n- La copie de votre CNI\n\nVeuillez-vous connecter à votre espace pour communiquer ces informations.")
    }
    if(type === "dossier_complete"){
      setTyp(type)
      setMessage("Votre demande effectuée sur la plateforme GUE-PME est à présent complète. Elle est en cours de traitement pour préparer votre prochain RDV avec un conseiller client au siège de GUE-PME.\n\nNous vous remercions et à très bientôt !")
      setText("Notification de dossier au complet")
      setLien("")
    }
  }

  useEffect(()=>{
    const urlencodedtext = encodeURIComponent(`Bonjour ${user.firstname} ${user.lastname},\n\n${message}\n\GUE-PME,\nLe Guichet Unique des PME`);
    const url = `https://wa.me/${user.whatsapp}/?text=${urlencodedtext}`; 
    setUrl(url)
  }, [message])

  function types(type){
    if(type=="Formalisation"){
      return "Accompagnement"
    }
    if(type=="Formation"){
      return "Garantie"
    }
    else{
      return type
    }
  }

  return (
    <div>
      {!location.pathname.includes("/mon-profile/") && (
        <div>
          <h1>Informations supplementaires</h1>
          <div class="col-10 col-md-4">Montant: {user.montant} CFA</div>
          <div class="col-10 col-md-4">
            Bilan financier:{" "}
            <a target="_blank" href={`${staticUrl}/uploads/${user.bilan}`}>
              Voir
            </a>
          </div>
          <div class="col-10 col-md-4">
            Pièce d'identité:{" "}
            <a target="_blank" href={`${staticUrl}/uploads/${user.piece}`}>
              Voir
            </a>
          </div>

          <div class="col-12 my-4 d-flex btn-conteneur gap-sm-1 p-0">
            <button
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              className="btn-details-demande shadow col-11 col-sm-3"
              onClick={() => handleMail("information")}
            >
              Demande d'information supplementaires
            </button>

            <button
              onClick={() => handleMail("dossier_complete")}
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              className="btn-details-demande shadow col-11 col-sm-3"
            >
              Confirmation de dossier au complet
            </button>

            <button
              onClick={() => handleMail("calendar")}
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              className="btn-details-demande shadow col-11 col-sm-3"
            >
              Envoyer mail de prise de rendez-vous
            </button>

            <button
              onClick={() => handleMail("finalisation")}
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              className="btn-details-demande shadow col-11 col-sm-3"
            >
              Envoyer mail de finalisation de procédure
            </button>

            
          </div>
          
          {message && (
            <div class="col-12 my-4 d-flex btn-conteneur gap-sm-1 p-0">
              <a
              href={url}
              className="btn-details-demande shadow col-11 col-sm-3"
              style={{color: "white !important"}}
            >
              Envoyer une copie par whatsapp
            </a>
            </div>
          )}

          {
            print ? 
            (
              <button className="btn-details px-3 py-1 shadow d-flex justify-content-center">Téléchargement en cours. Partientez...</button>
            )
            :
            (
              <button className="btn-details px-3 py-1 shadow d-flex justify-content-center" onClick={handlePrint}>Télécharger le profil</button>
            )
          }
          
        </div>
      )}

      <form class="ml-3 mr-2 mt-3 row g-3" ref={tableRef}>
        <h1 style={{textAlign:"center"}}>Profil de {user.firstname} {user.lastname}</h1>
        {/* <div class="col-lg-4">
          <label for="nom" class="form-label">
            Type
          </label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="firstname"
            value={types(user.type)}
            onChange={handleChange}
            required
          />
        </div> */}
        <div class="col-lg-4">
          <label for="category" class="form-label">
            Category
          </label>
          <input
            type="text"
            class="form-control"
            id="category"
            name="category"
            onChange={handleChange}
            value={user.category =="PME"? "PME / Startup" : user.category =="Startup"? "Groupement": user.category}
            required
          />
        </div>
        <div class="col-lg-8">
          <label for="activite" class="form-label">
            Activité
          </label>
          <input
            type="text"
            class="form-control"
            id="activite"
            name="activite"
            onChange={handleChange}
            value={user.activite}
            required
          />
        </div>

        {user && user?.informations && user?.informations[0] && (
          <div class="col-lg-6">
          <label for="information" class="form-label">
            Besoin exprimé
          </label>
          <input
            type="text"
            class="form-control"
            id="information"
            name="information"
            onChange={handleChange}
            value={user?.informations[0].information}
            required
          />
        </div>
        )}

        {user && user?.formalisations && user?.formalisations[0] && (
          <div class="col-lg-6">
          <label for="formalisation" class="form-label">
            Besoin exprimé
          </label>
          <input
            type="text"
            class="form-control"
            id="formalisation"
            name="formalisation"
            onChange={handleChange}
            value={user?.formalisations[0].formalisation ? "Accompagnement" : ""}
            required
          />
        </div>
        )}

        {user && user?.formations && user?.formations[0] && (
          <div class="col-lg-6">
          <label for="information" class="form-label">
            Besoin exprimé
          </label> 
          <input
            type="text"
            class="form-control"
            id="formation"
            name="formation"
            onChange={handleChange}
            value={user?.formations[0].formation? "Garantie": ""}
            required
          />
        </div>
        )}

        {user && user?.financements && user?.financements[0] && (
          <div class="col-lg-6">
          <label for="financement" class="form-label">
            Besoin exprimé
          </label> 
          <input
            type="text"
            class="form-control"
            id="financement"
            name="financement"
            onChange={handleChange}
            value={user?.financements[0].financement}
            required
          />
        </div>
        )}

        {user && user?.projects && user?.projects[0] && (
          <div class="col-lg-6">
          <label for="project" class="form-label">
            Projet
          </label>
          <input
            type="text"
            class="form-control"
            id="project"
            name="project"
            onChange={handleChange}
            value={user?.projects[0].project}
            required
          />
        </div>
        )}

        <div class="col-lg-6">
          <label for="nom" class="form-label">
            Mon nom
          </label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="firstname"
            value={user.firstname}
            onChange={handleChange}
            required
          />
        </div>
        <div class="col-lg-6">
          <label for="prenom" class="form-label">
            Mon prénom
          </label>
          <input
            type="text"
            class="form-control"
            id="prenom"
            name="lastname"
            onChange={handleChange}
            value={user.lastname}
            required
          />
        </div>
        <div class="col-lg-6">
          <label for="sexe" class="form-label">
            Mon sexe
          </label>
          <select
            class="form-select"
            id="sexe"
            name="gender"
            onChange={handleChange}
            required
          >
            <option selected disabled value="">
              Choisissez...
            </option>
            <option
              value="Femme"
              selected={user.gender == "Femme" ? true : false}
            >
              Femme
            </option>
            <option
              value="Homme"
              selected={user.gender === "Homme" ? true : false}
            >
              Homme
            </option>
          </select>
        </div>

        <div class="col-lg-6">
          <label for="age" class="form-label">
            Ma tranche d'age
          </label>
          <select
            class="form-select"
            id="age"
            name="agerange"
            onChange={handleChange}
            required
          >
            <option selected disabled value="">
              Choisissez...
            </option>
            <option
              value="16 - 35 ans"
              selected={user.agerange == "16 - 35 ans" ? true : false}
            >
              16 - 35 ans
            </option>
            <option
              value="36 - 40 ans"
              selected={user.agerange == "36 - 40 ans" ? true : false}
            >
              36 - 40 ans
            </option>
            <option
              value="41 ans et plus"
              selected={user.agerange == "41 ans et plus" ? true : false}
            >
              41 ans et plus
            </option>
          </select>
        </div>

        <div className="col-lg-6">
          <p>Êtes-vous en situation d'handicap ?</p>
          <div className="d-flex gap-5">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="handicap"
                value="true"
                onChange={handleChange}
                id="ouiHandicap"
                checked={user.handicap == "1" ? true : false}
              />
              <label class="form-check-label" for="ouiHandicap">
                Oui
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="handicap"
                value="false"
                onChange={handleChange}
                id="nonHandicap"
                checked={user.handicap == "0" ? true : false}
              />
              <label class="form-check-label" for="nonHandicap">
                Non
              </label>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <p>Où résidez-vous ?</p>
          <div className="d-flex gap-5">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="diapora"
                value="true"
                onChange={handleChange}
                id="ouiDiaspora"
                checked={user.diapora == "1" ? true : false}
              />
              <label class="form-check-label" for="ouiDiaspora">
                Intérieur
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="diapora"
                value="false"
                onChange={handleChange}
                id="nonDiaspora"
                checked={user.diapora == "0" ? true : false}
              />
              <label class="form-check-label" for="nonDiaspora">
                Abidjan
              </label>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <label for="mobile" class="form-label">
            Telephone mobile
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <FaPhoneFlip className="" />
            <input
              type="text"
              class="form-control border-0"
              id="mobile"
              name="phone"
              value={user.phone}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div class="col-lg-6">
          <label for="whatsapp" class="form-label">
            Whatsapp
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <FaWhatsapp />
            <input
              type="text"
              class=" border-0 form-control"
              id="whatsapp"
              name="whatsapp"
              onChange={handleChange}
              value={user.whatsapp}
              required
            />
          </div>
        </div>
        <div class="col-lg-6">
          <label for="email" class="form-label">
            Adresse email
          </label>
          <div className="d-flex py-1 px-2 justify-content-center bg-white align-items-center border rounded">
            <GrMail />
            <input
              type="email"
              class="border-0 form-control"
              id="email"
              name="email"
              onChange={handleChange}
              value={user.email}
              required
            />
          </div>
        </div>
        <div class="col-lg-6">
          <label for="commune" class="form-label">
            Commune
          </label>
          <div className="p-1 bg-white border rounded">
            <input
              type="text"
              class=" border-0 form-control"
              id="commune"
              name="city"
              onChange={handleChange}
              value={user.city}
              required
            />
          </div>
        </div>

      {user && user?.entreprenants && user?.entreprenants[0] && (
      < >
        <div class="col-md-6">
          <label for="adresse" class="form-label">
            Adresse de l'activité
          </label>
          <input
            type="text"
            class="form-control"
            id="adresse"
            name="address"
            value={user?.entreprenants[0].address}
            onChange={handleChange}
            required
          />
        </div>
        {/* <div class="col-md-6">
          <label for="secteurActivite" class="form-label">
            Secteur de l'activité
          </label>
          <input
            type="text"
            class="form-control"
            id="secteurActivite"
            name="sector"
            onChange={handleChange}
            value={user?.entreprenants[0].sector}
            required
          />
        </div> */}
        </>
      )}

    {identification && (
      < >

        <div class="col-lg-6">
          <label for="adresse" class="form-label">
            Adresse de l'activité
          </label>
          <input
            type="text"
            class="form-control"
            id="adresse"
            name="address"
            value={identification.address}
            onChange={handleChange}
            required
          />
        </div>
        {/* <div class="col-lg-6">
          <label for="secteurActivite" class="form-label">
            Secteur de l'activité
          </label>
          <input
            type="text"
            class="form-control"
            id="secteurActivite"
            name="sector"
            onChange={handleChange}
            value={identification.sector}
            required
          />
        </div> */}

        <div class="col-lg-6">
          <label for="denomination" class="form-label">
            {isPme?"Dénomination":"Nom du groupement"}
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="denomination"
              name="denomination"
              value={identification.denomination =="PME"? "PME / Startup" : identification.denomination =="Startup"? "Groupement": identification.denomination}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div class="col-lg-6">
          <label for="secteurActivite" class="form-label">
            {isPme?"Secteur d'activité":"Type de groupement"}
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="secteurActivite"
              name="sector"
              value={identification.sector}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div class="col-lg-6">
          <label for="numeroRC" class="form-label">
            {isPme?"Numero de registre de commerce":"Objet social"}
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="numeroRC"
              name="nrc"
              value={identification.nrc}
              onChange={handleChange}
            />
          </div>
        </div>
        <div class="col-lg-6">
          <label for="numeroCC" class="form-label">
            {isPme?"Numero de compte contribuable":"Forme juridique"}
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="numeroCC"
              name="ncc"
              value={identification.ncc}
              onChange={handleChange}
            />
          </div>
        </div>

        <div class="col-lg-6">
          <label for="telephone" class="form-label">
            {isPme?"Numéro de télephone":"Régime fiscal"}
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            {isPme? (<FaPhoneFlip />) :null}
            <input
              type="text"
              class="form-control border-0"
              id="phone"
              name="phone"
              value={identification.phone}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div class="col-lg-6">
          <label for="email" class="form-label">
            {isPme?"Adresse email entreprise":"Secteur d’activité"}
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            {isPme? (<GrMail />) :null}
            <input
              type="email"
              class="form-control border-0"
              id="email"
              name="email"
              onChange={handleChange}
              value={identification.email}
              required
            />
          </div>
        </div>

        <div class="col-lg-6">
          <label for="adresse" class="form-label">
            {isPme? "Aresse du siège" : "Nombre de membre"}
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="adresse"
              name="address"
              value={identification.address}
              onChange={handleChange}
            />
          </div>
        </div>

        <div class="col-lg-6">
          <label for="siteWeb" class="form-label">
            {isPme ? "Site web" : "Avez-vous un agrément ?"}
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            {isPme ? (<FaLink />) : null}
            <input
              type="text"
              class="form-control border-0"
              id="siteWeb"
              name="website"
              onChange={handleChange}
              value={identification.website == true ? "Oui":"Non"}
            />
          </div>
        </div>

        {!isPme && (
          <div class="col-lg-6">
            <label for="siteWeb" class="form-label">
            Avez-vous un récépissé de dépôt de demande d'agrément?
            </label>
            <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
              <input
                type="text"
                class="form-control border-0"
                id="siteWeb"
                name="agrement"
                onChange={handleChange}
                value={identification.agrement == true ? "Oui":"Non"}
              />
            </div>
          </div>
        )}

        <div class="col-lg-6">
          <label for="siteWeb" class="form-label">
          Comment avez-vous connu le GUDE?
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="siteWeb"
              name="reconnaissance"
              onChange={handleChange}
              value={identification.reconnaissance}
            />
          </div>
        </div>

    </>
    )}
      </form>
      {/* {
        !location.pathname.includes('/mon-profile/') && (
          <div class="col-lg-6 mb-4">
            <button
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                className="d-flex btn-details px-3 py-1 shadow d-flex justify-content-center"
                onClick={() => handleMail("information")}
              >
                Demande d'information supplementaires
              </button>
          </div>
        )
      } */}

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{text}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="message-text" class="col-form-label">Voulez-vous confirmer l'envoie de la notification ?</label>
                {/* <textarea 
                  class="form-control"
                  id="message-text"
                  rows="10"
                  name="message"
                  onChange={(e)=>setMessage(e.target.value)}
                  value={message}
                >

                </textarea> */}
              </div>
            </form>
          </div>
          
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
            <button type="button" onClick={() => handleDetailClick(user.email)} class="btn btn-primary">
              {load? "Partientez...": "Confirmer"}
            </button>
          </div>
          
        </div>
      </div>
    </div>

</div>

  );
};

export default DetailPage;
